import type { DataOperationResult, ObjetK } from '@siclop/kstone-vue'

/** Partie d'un store createKsStore utile à l'enregistrement. */
export interface SavableStore<TModel extends ObjetK> {
  itemForm: unknown
  save(maj?: boolean): Promise<DataOperationResult<TModel>>
}

/**
 * Enregistre un formulaire par le store de l'entité plutôt que par son service : même appel
 * d'API, mais le store est mis à jour localement quand SignalR n'est pas connecté (listes à jour
 * sans rechargement). Équivaut à `store.itemForm = form; store.save()`.
 *
 * @example
 * useEntityDetailView({ save: form => saveThroughStore(useLeaveTypeStore(), form), … })
 */
export function saveThroughStore<TModel extends ObjetK>(
  store: SavableStore<TModel>,
  form: unknown
): Promise<DataOperationResult<TModel>> {
  store.itemForm = form
  return store.save()
}
